import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftBoxResponse, GiftCouponStatus } from '@models/gift';
import { GiftCouponStatusKr } from '@models/gift/extension';
import { Fragment } from 'react';

import styles from './styles.module.scss';

interface Props {
    giftBox: GiftBoxResponse;
}

function GiftItem({ giftBox }:Props) {
  const { giftItemType, giftCoupon, giftCard } = giftBox;
  return (
        <Column fullWidth align='center'
                className={styles.container}>

            <Text size='2xl' fontWeight='medium'
                  color={colors.gray7}>
                {giftCoupon?.name || giftCard?.name}
            </Text>

            {giftItemType === 'PRODUCT' && (
                <Row className={styles.exrpires} spacing={4}>
                    <Text size='lg' color={colors.gray6} fontWeight='bold'>
                        유효기간
                    </Text>
                    <Text color={colors.gray6}>
                        2025.05.24. 23:59까지
                    </Text>
                </Row>
            )}
            {giftCoupon && (
                <Fragment>
                    <div className={styles.item}>
                        <Image src='/dummy/img_4.png'
                               width={106}
                               height={106}
                               alt='선물 상품 이미지' />
                        {giftCoupon.status !== GiftCouponStatus.DEACTIVATED && (
                            <span className={`${styles.badge} `}>
                        {GiftCouponStatusKr[giftCoupon.status]}
                    </span>
                        )}
                    </div>
                    <Text size='3xl' fontWeight='bold'>5,500원</Text>
                </Fragment>
            )}
            {giftCard && (
                <Image src='/dummy/img_5.png'
                       className={styles.card}
                       width={200}
                       height={134}
                       alt='선불카드 선물' />
            )}

        </Column>
  );
}

export default GiftItem;
